import React, { useState } from 'react';
import { useI18n } from '../../i18n';
import { Globe, ChevronDown } from 'lucide-react';

const LanguageSwitcher = ({ variant = 'dark' }) => {
  const { lang, setLang, languages } = useI18n();
  const [open, setOpen] = useState(false);
  const current = languages.find((l) => l.code === lang) || languages[0];

  const buttonCls = variant === 'light'
    ? 'bg-white/90 text-slate-900 border-slate-200 hover:bg-white'
    : 'bg-white/5 text-slate-100 border-white/10 hover:bg-white/10';

  return (
    <div className="relative" onMouseLeave={() => setOpen(false)}>
      <button
        onClick={() => setOpen((v) => !v)}
        className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-semibold transition-colors ${buttonCls}`}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <Globe className="h-3.5 w-3.5" />
        <span>{current?.flag}</span>
        <span className="uppercase">{current?.code}</span>
        <ChevronDown className={`h-3 w-3 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 min-w-[160px] rounded-xl border border-slate-200 bg-white shadow-xl overflow-hidden z-50">
          {languages.map((l) => (
            <button
              key={l.code}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`w-full text-left px-3 py-2 text-sm flex items-center gap-2 hover:bg-orange-50 ${
                l.code === lang ? 'bg-orange-50 text-orange-700 font-semibold' : 'text-slate-800'
              }`}
            >
              <span>{l.flag}</span>
              <span>{l.name}</span>
              <span className="ml-auto text-[10px] uppercase text-slate-400">{l.code}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
